import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
import accRechRankByDayOne from "./accRechRankByDayOne";
import accRechRankByDayOneSummary from "./accRechRankByDayOneSummary";
import { tabulation } from "@/mixins/index";
export default {
  name: "accRechRankByDay",
  mixins: [tabulation],
  components: {
    accRechRankByDayOne: accRechRankByDayOne,
    accRechRankByDayOneSummary: accRechRankByDayOneSummary
  },
  data: function data() {
    return {
      activeIndex: 'accRechRankByDayOne'
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    modelChange: function modelChange(e) {
      this.activeIndex = e;
      this.$refs[e].comInit && this.$refs[e].comInit();
    }
  }
};